// extracted by mini-css-extract-plugin
export var open = "styles-module--open--+lyZV";
export var scrExpanded = "styles-module--scrExpanded--6537H";
export var label = "styles-module--label--WZt4f";